export enum AlertsType {
  success = 'success',
  error = 'error',
  warning = 'warning'
}
